export const DISMISS_ACTIVATE_ACCOUNT_MODAL = 'dismiss-activate-account-modal';
export const DISMISS_ACTIVATE_MODAL_COOKIE_NAME = 'pw-activate-dismissed';
const dismissActivateAccountModal = () => ({ type: DISMISS_ACTIVATE_ACCOUNT_MODAL });
export default dismissActivateAccountModal;
